import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const filtros = {
	state: {
		filtros : {
			practicas : {
				titulacion: '',
				codAsignatura: '', 
				tipoPractica: '',
				curso: '',
				f_inicio_desde: '',
				f_inicio_hasta: '',
				f_fin_desde: '',
				f_fin_hasta: '',
				puesto: '',
				nombreComercialEmpresa: ''
			}
		}
	},
	getters: {
		getfiltrosPracticas : state => state.filtros.practicas,   
	}, 
	actions: {
		requestSetFiltroPracticas : function({commit}, data){
			commit('setfiltrosPracticas',data);
		}
	},
	mutations: {
		setfiltrosPracticas : function(state,data){
			state.filtros.Practicas = data;
		}
	}
}

export default filtros;



// WEBPACK FOOTER //
// ./src/store/filtros.js